import React, { Component } from "react";
import api from "services/api";
import {
  Button,
  Card,
  Descriptions,
  Flex,
  List,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";
import { DateTime } from "luxon";
import NavigationService from "services/navigation";
import UserService from "services/user";
import store from "data/store";
import { observer } from "mobx-react";
import ApplicationService from "services/application";

class ProfilePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      const { data } = await api.getProfile();
      this.setState({
        loading: false,
        ...data,
      });
    } catch (err) {
      console.log("err", err);
    }
  }

  createReport = async () => {
    const { data } = await api.createReport();
    this.navigateToReport(data.id);
  };

  navigateToReport = (reportId) =>
    NavigationService.navigate(`/reports/${reportId}`);

  render() {
    if (this.state.loading) return <Spin fullscreen={true} />;

    const formatedCreatedAt = DateTime.fromISO(
      this.state.user.createdAt
    ).toFormat("dd.MM.yyyy HH:mm");

    return (
      <Flex style={{ flex: 1 }} vertical>
        <Card
          title="Profile"
          style={{ overflowY: "scroll" }}
          extra={[
            <Button danger type="primary" onClick={ApplicationService.logout}>
              logout
            </Button>,
          ]}
        >
          <Space direction="hotizontal"></Space>
          <Button
            danger
            type="primary"
            onClick={
              store.workSessionAvailable
                ? UserService.endWorkSession
                : UserService.startWorkSession
            }
          >
            {store.workSessionAvailable
              ? "Конец смены для отчетов"
              : "Старт смены для отчетов"}
          </Button>
          <Descriptions
            title={this.state.user.email}
            style={{ marginTop: "20px" }}
          >
            <Descriptions.Item label="Регистрация">
              {formatedCreatedAt}
            </Descriptions.Item>
            <Descriptions.Item label="Кол-во чатов">
              {this.state.user.chatsCount}
            </Descriptions.Item>
            <Descriptions.Item label="Кол-во оставленных заметок">
              {this.state.user.notesCount}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions title="Последняя сессия (12 часов)">
            <Descriptions.Item label="Кол-во чатов">
              {this.state.lastWorkSessionData.chatRoomsCount}
            </Descriptions.Item>
            <Descriptions.Item label="Кол-во оставленных заметок">
              {this.state.lastWorkSessionData.notesCount}
            </Descriptions.Item>
            <Descriptions.Item label="Кол-во чатов без комментариев">
              {this.state.lastWorkSessionData.withoutNotesRoomsCount}
            </Descriptions.Item>
          </Descriptions>
          <List
            header={
              <Row align="middle" justify="space-between">
                <Typography.Text>Отчеты (последние 5 шт.)</Typography.Text>
                <Button
                  type="primary"
                  disabled={
                    !store.workSession ||
                    !store.workSession.startedAt ||
                    !store.workSession.endedAt
                  }
                  onClick={this.createReport}
                >
                  Создать отчет
                </Button>
              </Row>
            }
            dataSource={this.state.reports}
            renderItem={(report) => (
              <List.Item
                actions={[
                  <Button
                    type="primary"
                    onClick={() => this.navigateToReport(report.id)}
                  >
                    Посмотреть
                  </Button>,
                ]}
              >
                <List.Item.Meta
                  title={DateTime.fromISO(report.createdAt).toFormat(
                    "dd.MM.yyyy HH:mm"
                  )}
                />
              </List.Item>
            )}
          />
        </Card>
      </Flex>
    );
  }
}

export default observer(ProfilePage);
